import React, { Component } from "react";
import { Row, Col, Card, CardBody, Form } from "reactstrap";
import moment from "moment";
import get from "lodash/get";
import history from "../../history";
import CartTitle from "../../components/CartTitle";
import Loader from "../Loader";
import InputText from "../InputText";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../CustomButton";
import MaterialTable from "material-table";
import { nameValidation, emailValidation } from "../../utils/helperFunction";

import "../../assets/scss/components/MeterialTable/index.scss";

const _ = { get };

export default class UserListing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleActive: false,
      page: 0,
      phone: "",
      email: "",
      limit: 100,
      data: [],
    };
  }

  componentDidMount() {
    this.props.handleClearPreviousReducers();
    window.sessionStorage.removeItem("member");
    window.sessionStorage.removeItem("prevFlag");
    window.sessionStorage.removeItem("userRegistrationEmail");
    window.sessionStorage.removeItem("userRegistrationPhone");
  }

  handleFilterChange = (e, id) => {
    this.props.handleClearPreviousReducers();
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  handleRowData = (rowData) => {
    if (rowData.ridersClubMember !== true) {
      history.push(
        `/user/detail?cluster=${rowData.cluster}&guid=${rowData.guid}&userId=${rowData._id}`
      );
    } else {
      history.push(
        `/rides/member-detail?guid=${rowData.guid}&id=${rowData._id}&vehicleId=${rowData._id}`
      );
    }
  };

  handleToCreateUser = () => {
    history.push("/user/creation");
    sessionStorage.setItem("userRegistrationEmail", this.state.email);
    sessionStorage.setItem("userRegistrationPhone", this.state.phone);
  };

  handleSubmitFilter = (e) => {
    e.preventDefault();
    let state = this.state;
    let { elements } = this.props;
    let data = {
      page: state.page,
      phone: state.phone.toLowerCase().trim(),
      email: state.email.toLowerCase().trim(),
      limit: state.limit,
    };
    let value = data.email;
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (data.email !== "") {
      if (emailPattern.test(value) === true) {
        if (data.phone !== "") {
          if (data.phone.length >= 8 && data.phone.length <= 15) {
            this.props.handleFetchAllUser(data);
            this.props.handleSearchFilter();
          } else {
            toast.error(
              _.get(
                elements,
                "userListingFilterElements.phoneCharValidationElement",
                "phone Length should be more than 7 and less than 16"
              )
            );
          }
        } else {
          toast.error(
            _.get(
              elements,
              "userListingFilterElements.phoneEmptyValidationElement",
              "Phone cannot be empty"
            )
          );
        }
      } else {
        toast.error(
          _.get(
            elements,
            "userListingFilterElements.validEmailValidationElement",
            "Enter Valid Email"
          )
        );
      }
    } else {
      toast.error(
        _.get(
          elements,
          "userListingFilterElements.emailEmptyValidationElement",
          "Email cannot be empty"
        )
      );
    }
  };

  handleClearFilter = () => {
    let state = this.state;
    state.page = 0;
    state.phone = "";
    state.email = "";
    state.limit = "";
    this.setState({ ...state });
    this.props.handleFetchAllUser();
  };

  render() {
    let { elements } = this.props;
    return (
      <div className="userListing hideSearch">
        {this.props.allUserStatus !== false ? <Loader /> : null}
        <Form onSubmit={this.handleSubmitFilter}>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "userListingFilterElements.headingElement",
                  "User Registration"
                )}
                Name={"Filter"}
                handleToggle={() => this.handleToggle()}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
                iconClass={"hideexcel"}
              />
            </Col>

            <Col sm={12}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col lg={5}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "userListingFilterElements.emailLabel",
                          "Email"
                        )}
                        inputType={"text"}
                        inputName={"email"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "userListingFilterElements.emailPlaceholder",
                          "Email"
                        )}
                        customValue={this.state.email}
                        customOnChange={(e) =>
                          this.handleFilterChange(e, "email")
                        }
                      />
                    </Col>
                    <Col lg={5}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "userListingFilterElements.mobileLabel",
                          "Mobile Number"
                        )}
                        inputType={"number"}
                        inputName={"phone"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "userListingFilterElements.mobilePlaceholder",
                          `Mobile Number (exclude prefix '0')`
                        )}
                        customValue={this.state.phone}
                        customOnChange={(e) => this.handleFilterChange(e)}
                      />
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                    {this.props.userFilterStatus !== true &&
                    this.props.allUser.length === 0 &&
                    this.props.searchFilter === true ? (
                      // &&
                      // this.state.email !== "" &&
                      // this.state.phone !== ""
                      <CustomButton
                        customType={"button"}
                        name={_.get(
                          elements,
                          "userListingFilterElements.createUserElement",
                          "Create User"
                        )}
                        customClass={"btn-outline-dark  bg-none btnthemeColor"}
                        customClick={() => this.handleToCreateUser()}
                      />
                    ) : null}

                    <CustomButton
                      customType={"submit"}
                      name={_.get(
                        elements,
                        "userListingFilterElements.searchButtonElement",
                        "Search"
                      )}
                      customClass={
                        "btn-outline-dark ml-2 bg-none btnthemeColor"
                      }
                    />
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "userListingFilterElements.clearFilterButtonElement",
                        "Clear Filter"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                      }
                      customClick={() => this.handleClearFilter()}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
        <Row>
          <Col sm="12">
            <div className="custom-m-table">
              <MaterialTable
                title=""
                columns={[
                  {
                    title: _.get(
                      elements,
                      "userListingTableElements.nameElement",
                      "Name"
                    ),
                    field: "name",
                    render: (rowData) => `${rowData.fName} ${rowData.lName}`,
                  },
                  {
                    title: _.get(
                      elements,
                      "userListingTableElements.dateOfBirthElement",
                      "DOB"
                    ),
                    field: "dob",
                    render: (rowData) =>
                      moment(rowData.dob).format("DD-MM-YYYY"),
                  },
                  {
                    title: _.get(
                      elements,
                      "userListingTableElements.regionElement",
                      "Region"
                    ),
                    field: "cluster",
                    render: (rowData) => {
                      if (rowData.cluster === "EU0001") {
                        return "EUROPE";
                      }
                      if (rowData.cluster === "APAC0001") {
                        return "ASIA";
                      }
                      if (rowData.cluster === "IN0001") {
                        return "INDIA";
                      }
                    },
                  },
                  {
                    title: _.get(
                      elements,
                      "userListingTableElements.registrationElement",
                      "Registration"
                    ),
                    field: "ridersClubMember",
                    render: (rowData) =>
                      rowData.ridersClubMember ? "Registered" : "Available",
                  },
                  {
                    title: _.get(
                      elements,
                      "userListingTableElements.phoneElement",
                      "Phone"
                    ),
                    field: "phone",
                    render: (rowData) =>
                      rowData.contactDetails.mobile.primary.number,
                  },
                  {
                    title: _.get(
                      elements,
                      "userListingTableElements.emailElement",
                      "Email"
                    ),
                    field: "email",
                    render: (rowData) => rowData.contactDetails.email,
                  },
                ]}
                data={this.props.allUser}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: 10,
                }}
                actions={[
                  {
                    icon: "assignment_ind",
                    tooltip: "Detail Page",
                    onClick: (event, rowData) => this.handleRowData(rowData),
                  },
                ]}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "userListingTableElements.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "customMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "customMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "customMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                  header: {
                    actions: _.get(
                      elements,
                      "userListingTableElements.actionsElement",
                      "Actions"
                    ),
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
